module.exports = __webpack_public_path__ + "static/mushroomgroup-84f602f564a40417798327932f7edbd8.png";